import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { School, ExitToApp } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Academic Theme
const academicTheme = createTheme({
  palette: {
    primary: {
      main: "#1565C0",
    },
    secondary: {
      main: "#FF8F00",
    },
    background: {
      default: "#F8F9FA",
      paper: "#FFFFFF",
    },
  },
});

export default function SessionExpiredModal({ visible, onClose }) {
  return (
    <ThemeProvider theme={academicTheme}>
      <Dialog
        open={visible}
        onClose={() => {}} // ปิดการปิด modal โดยการคลิกข้างนอก
        aria-labelledby="session-expired-title"
        aria-describedby="session-expired-description"
        disableEscapeKeyDown // ปิดการปิด modal ด้วย ESC key
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(21,101,192,0.2)",
            minWidth: 400,
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", pb: 2, pt: 4 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <School sx={{ fontSize: 40, color: "white" }} />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#1565C0",
                mb: 1,
              }}
            >
              เซสชันหมดอายุ
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", px: 4 }}>
          <DialogContentText
            id="session-expired-description"
            sx={{
              fontSize: "1.1rem",
              color: "#666",
              lineHeight: 1.6,
              mb: 2,
            }}
          >
            เพื่อความปลอดภัยของข้อมูล กรุณาเข้าสู่ระบบใหม่อีกครั้ง
            เพื่อเข้าใช้งานระบบการเรียนรู้ออนไลน์
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", p: 4, pt: 2 }}>
          <Button
            onClick={onClose}
            variant="contained"
            size="large"
            startIcon={<ExitToApp />}
            sx={{
              background: "linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)",
              color: "white",
              px: 4,
              py: 1.5,
              borderRadius: 3,
              fontWeight: 600,
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: "0 4px 16px rgba(21,101,192,0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #0D47A1 0%, #1976D2 100%)",
                boxShadow: "0 6px 20px rgba(21,101,192,0.4)",
              },
            }}
          >
            กลับไปเข้าสู่ระบบ
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
